import type { QueryClient } from "@tanstack/react-query";
import { WaiversPoliciesApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export async function prefetchPolicyGet(
  policyId: number,
  queryClient: QueryClient,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching policy");
  }

  const service = createAuthenticatedApi(WaiversPoliciesApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Waivers, policyId],
    queryFn: () => service.getPolicyById({ id: policyId }),
    staleTime: 5 * 60 * 1000,
  });

  return queryClient;
}
